import React from "react";

const WindowChrome = ({ title, className = "", variant }) => (
  <div
    className={`cursor-window-chrome${variant === "case" ? " cursor-window-chrome-case" : ""} ${className}`.trim()}
  >
    <div className="cursor-window-dots" aria-hidden="true">
      <span className="cursor-dot cursor-dot-red" />
      <span className="cursor-dot cursor-dot-yellow" />
      <span className="cursor-dot cursor-dot-green" />
    </div>
    {title && <span className="cursor-window-title">{title}</span>}
  </div>
);

export default WindowChrome;
